import { render, staticRenderFns } from "./SaleReturnProductsForm.vue?vue&type=template&id=3d4812a4&scoped=true&"
import script from "./SaleReturnProductsForm.vue?vue&type=script&lang=js&"
export * from "./SaleReturnProductsForm.vue?vue&type=script&lang=js&"
import style0 from "./SaleReturnProductsForm.vue?vue&type=style&index=0&id=3d4812a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4812a4",
  null
  
)

component.options.__file = "SaleReturnProductsForm.vue"
export default component.exports